import { useDispatch, useSelector } from 'react-redux';
import { checkValidation, validations } from '../../constants/Validators';
import {
  changeEmail,
  changeMobile,
  changeUserData,
  changeUserName,
  createAccount,
  fillCreateAccountData, getDetailsFromOfficePinCode,
  captchaAndSessionId,
  getDetailsFromPinCode,
  toggleChoice,
} from '../travellersDetails/store/actions/NewAccountActions';
import {useEffect, useRef, useState} from "react";

// const mapStateToProps = (state) => {
//   const { newAccount } = state;
//   return {
//     ...newAccount,
//   };
// };
//
// const mapDispatchToProps= (dispatch) => ({
//   fillCreateAccountData:
//     () => dispatch(fillCreateAccountData),
//   changeUserData:
//     (key, value) => dispatch(changeUserData(key, value)),
//   toggleChoice:
//     (key) => dispatch(toggleChoice(key)),
//   getDetailsFromPinCode:
//     (pinCode) => dispatch(getDetailsFromPinCode(pinCode)),
//   getDetailsFromOfficePinCode:
//     (pinCode) => dispatch(getDetailsFromOfficePinCode(pinCode)),
//   changeUserName:
//     (name) => dispatch(changeUserName(name)),
//   changeEmail:
//     (email) => dispatch(changeEmail(email)),
//   changeMobile:
//     (mobileNumber) => dispatch(changeMobile(mobileNumber)),
//   createAccount:
//     (data) => dispatch(createAccount(data)),
// });
//
// export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreateNewAccount));

export function useCreateNewAccountContainer(props) {
  const dispatch = useDispatch();
  const { newAccount } = useSelector((state: any) => state);
  const [ showError, setError ] = useState(false);
  const [ rotate, setRotate ] = useState(false);
  const timerRef = useRef(null);
  const reviewData = props.location.state;

  useEffect(() => {
    dispatch(captchaAndSessionId())
    dispatch(fillCreateAccountData())
    return () => {
      clearTimeout(timerRef.current);
    };
  }, [])

  const _toggleChoice  = () => {
    dispatch(toggleChoice('officeCheckBoxEnabled'));
  };

  const _onReload = () =>  dispatch(captchaAndSessionId());

  const closeModal = () => {
    dispatch(toggleChoice('createAccountError'));
  };

  const _getDetailsFromPinCode = (pinCode) => {
    dispatch(getDetailsFromPinCode(pinCode));
  };

  const _getDetailsFromOfficePinCode = (pinCode) => {
    dispatch(getDetailsFromOfficePinCode(pinCode));
  };

  const _changeUserName = (name) => {
    dispatch(changeUserName(name));
  };

  const _changeEmail = (email) => {
    dispatch(changeEmail(email));
  };

  const _changeMobile = (mobileNumber) => {
    dispatch(changeMobile(mobileNumber));
  };

  const _changeUserData = (key, value) => {
    dispatch(changeUserData(key, value));
  };

  const buttonClicked = () => {
    setRotate(true);
    timerRef.current = setTimeout(() => {
      setRotate(false);
    }, 3000);
    const { officeCheckBoxEnabled, userNameErrorMessage, emailErrorMessage,
      mobileErrorMessage, pinCodeErrorMessage, officePinCodeErrorMessage } = props;
    const userData = [
      'userName',
      'password',
      'securityQuestion',
      'securityAnswer',
      'language',
      'firstName',
      'lastName',
      'gender',
      'email',
      'mobileNumber',
      'dateOfBirth',
      'occupation',
      'maritalStatus',
      'residentialAddress',
      'residentialMobileNumber',
      'pinCode',
      'city',
      'regionalState',
      'postOffice',
      'enterCaptcha',
      'country',
      ...(
        officeCheckBoxEnabled ?
          [
            'officeAddress',
            'officeMobileNumber',
            'officePinCode',
            'officeCity',
            'officeRegionalState',
            'officePostOffice',
            'officeCountry',
          ]:[]
      ),
    ];
    const valid = userData.every((item) => {
      return checkValidation(newAccount[item], validations[item]);
    });
    const enabled = valid && !userNameErrorMessage && !emailErrorMessage
      && !mobileErrorMessage && !pinCodeErrorMessage && !officePinCodeErrorMessage;
    if (enabled) {
      setError(false);
      const data = userData.reduce((a, key) => ({ ...a, [key]: newAccount[key] }), {});
      dispatch(createAccount({ ...data, officeCheckBoxEnabled }));
    } else {
      setRotate(false);
      setError(true);
    }
  };

  return {
    state: {
      newAccount,
      rotate,
      showError,
      reviewData
    },

    action: {
      buttonClicked,
      _toggleChoice,
      closeModal,
      _changeEmail,
      _changeMobile,
      _changeUserData,
      _changeUserName,
      _getDetailsFromOfficePinCode,
      _getDetailsFromPinCode,
      _onReload
    }
  };
}
